var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 37.5C29.665 37.5 37.5 29.665 37.5 20C37.5 10.335 29.665 2.5 20 2.5C10.335 2.5 2.5 10.335 2.5 20C2.5 29.665 10.335 37.5 20 37.5ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 12C31.9999 13.1046 31.1044 14 29.9999 14C28.8953 14 27.9999 13.1046 27.9999 12C27.9999 10.8954 28.8953 10 29.9999 10C31.1044 10 31.9999 10.8954 31.9999 12Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9999 12.75C30.4141 12.75 30.7499 12.4142 30.7499 12C30.7499 11.5858 30.4141 11.25 29.9999 11.25C29.5857 11.25 29.2499 11.5858 29.2499 12C29.2499 12.4142 29.5857 12.75 29.9999 12.75ZM29.9999 14C31.1044 14 31.9999 13.1046 31.9999 12C31.9999 10.8954 31.1044 10 29.9999 10C28.8953 10 27.9999 10.8954 27.9999 12C27.9999 13.1046 28.8953 14 29.9999 14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 25.5C23.0377 25.5 25.5001 23.0376 25.5001 20C25.5001 16.9624 23.0377 14.5 20.0001 14.5C16.9626 14.5 14.5001 16.9624 14.5001 20C14.5001 23.0376 16.9626 25.5 20.0001 25.5ZM20.0001 28C24.4184 28 28.0001 24.4183 28.0001 20C28.0001 15.5817 24.4184 12 20.0001 12C15.5818 12 12.0001 15.5817 12.0001 20C12.0001 24.4183 15.5818 28 20.0001 28Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.8d1dd78c85c20debca6cc155a1f7d194.svg";
export { ForwardRef as ReactComponent };